module.exports = __webpack_public_path__ + "static/media/harrington.59f3c47c.png";